export default __webpack_public_path__ + "static/media/th.1a247fe3.svg";